// =========================================================
// SECTION AVIS GOOGLE — Splide en BOUCLE (type loop : pas de butée trimSpace,
// l'Autoplay natif ne dérive pas — contrairement aux carousels promos/news).
// 3 cartes desktop / 2 tablette / 1 mobile, bullets, pause au survol.
// =========================================================
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-avis__splide').forEach((el) => {
        if (el.dataset.kmAvisInitialized) return;
        el.dataset.kmAvisInitialized = '1';

        new Splide(el, {
            type: 'loop',
            perPage: 2, // la synthèse est FIXE hors carousel (retour Olivier)
            perMove: 1,
            gap: '2rem',
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
            pauseOnFocus: false,
            speed: 700,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            reducedMotion: {speed: 700, rewindSpeed: 700}, // glisse conservée (politique Olivier)
            breakpoints: {
                991: {perPage: 1, gap: '1.25rem'},
            },
        }).mount();
    });

});
